export type WaitTimer = (ms?: number) => Promise<unknown>;

export type SetTimer = (cb: () => void, ms: number) => void;

export type IntervalRef = number;

export type SetInterval = (cb: () => void, ms: number) => IntervalRef;

export type ClearInterval = (intervalRef: IntervalRef) => void;

type TimerUtil = {
  waitTimer: WaitTimer;
  setTimer: SetTimer;
  setInterval: SetInterval;
  clearInterval: ClearInterval;
};

export const timerUtils: TimerUtil = {
  waitTimer: (ms = 1000) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    }),
  setTimer: (cb, ms) => setTimeout(cb, ms),
  setInterval: (cb, ms) => window.setInterval(cb, ms),
  clearInterval: (intervalRef) => window.clearInterval(intervalRef),
};
